module.exports = __webpack_public_path__ + "img/black-arrow-down-icon.1db9de09.png";